module.exports = __webpack_public_path__ + "static/img/11.097b2225.png";